module.exports = __webpack_public_path__ + "static/media/icon.3de93b91.svg";